export interface VersionLine {
	major: number;
	minor: number;
}

// Prioritize corridors carry `road_name` from the v2.4 line onward.
export const PRIORITIZE_ROAD_NAME_MIN: VersionLine = { major: 2, minor: 4 };

// Identify curves carry `curve_angle` from the v2.4 line onward.
export const CURVE_ANGLE_MIN: VersionLine = { major: 2, minor: 4 };

// Gates on the numeric major.minor line, so every build in it (RC, patch or final) qualifies.
export function isAtLeastVersion(version: string | undefined, min: VersionLine): boolean {
	const match = version?.match(/^v?(\d+)\.(\d+)/i);
	if (!match) return false;
	const major = Number(match[1]);
	const minor = Number(match[2]);
	return major > min.major || (major === min.major && minor >= min.minor);
}
